import React, {  useEffect } from "react";
import {  Container } from "react-bootstrap";
import MyLanding from "./MyLanding";
import Nav from "./Navbar";
import Footer from "./Footer";
const Blog = () => {



  return (
    <>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        {/* home */}

        <div>
          <Nav />
        </div>
        <div className="container p-0">
          <div className="mt-md-4">
            <div className="row  mx-md-0 mx-3 ">
              <div className="col-md-1 "></div>
              <div className="col-md-10 col-12 m-0 p-0">
                <div
                  className="row "
                  style={{ overflow: "hidden", height: "auto" }}
                >
                  <div className=" col-12 m-0 p-0 ">
                    <div className="" style={{ marginRight: "" }}>
                      <MyLanding />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-1"></div>
            </div>
          </div>
        </div>

        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default Blog;
